import { useState } from 'react';
import { useAuth } from '../AuthContext';
import { useTheme } from '../ThemeContext';
import { IconBank, IconChat, IconMoon, IconRefresh, IconSun } from '../components/Icons';
import BrandLogo from '../components/BrandLogo';

export default function Login() {
  const { login } = useAuth();
  const { theme, toggle } = useTheme();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(form.email, form.password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="tenant-auth-shell">
      <button onClick={toggle} className="tenant-auth-theme" title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
        {theme === 'dark' ? <IconSun size={18} /> : <IconMoon size={18} />}
      </button>

      <section className="tenant-auth-story">
        <BrandLogo />

        <div className="tenant-auth-copy">
          <div className="eyebrow">Tu negocio, bajo control</div>
          <h1>Vende, cobra y renueva sin perder el hilo.</h1>
          <p>Todo lo que necesitas para manejar cuentas y perfiles de streaming desde una sola operación.</p>
        </div>

        <div className="tenant-auth-features">
          <div><span><IconBank size={19} /></span><strong>Inventario claro</strong><p>Conoce cuántos perfiles tienes libres.</p></div>
          <div><span><IconRefresh size={19} /></span><strong>Vencimientos al día</strong><p>Anticípate a cada renovación.</p></div>
          <div><span><IconChat size={19} /></span><strong>Cobro por WhatsApp</strong><p>Mensajes listos con un clic.</p></div>
        </div>
      </section>

      <section className="tenant-auth-form-side">
        <div className="tenant-auth-form-card">
          <div className="eyebrow">Acceso para vendedores</div>
          <h2>Bienvenido de nuevo</h2>
          <p>Ingresa con los datos que te entregó el administrador.</p>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <label className="field-label">Correo
              <input className="input mt-2" type="email" placeholder="tu@negocio.com" value={form.email} onChange={set('email')} required />
            </label>
            <label className="field-label">Contraseña
              <input className="input mt-2" type="password" placeholder="Tu contraseña" value={form.password} onChange={set('password')} required />
            </label>
            {error && <p className="form-error">{error}</p>}
            <button className="btn-primary w-full" disabled={busy}>{busy ? 'Verificando…' : 'Entrar a mi espacio'}</button>
          </form>
          <div className="tenant-auth-help">¿Necesitas acceso? Solicítalo al administrador de StreamControl.</div>
        </div>
      </section>
    </div>
  );
}
